<template>
    <div>
        <template v-if="data">
            <div class="nj-flx g12">
                <Fecha :data="data" />
                <Hora :data="data" />
            </div>
        </template>
    </div>
</template>

<script>
import Fecha from "../components/Fecha"
import Hora from "../components/Hora"

export default {
    name: "FechaHora",
    components: {
        Fecha,
        Hora
    },
    props: {
        data: {
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showPlaceholders: {
            type: Boolean,
            default: true
        }
    },
}
</script>

<style scoped></style>